/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { TableWrapper } from "../../../shared/layout";
import { templateStrings } from "../../../Constant";
import { vehicleWiseCardCollectionListAction } from "../../../redux/action-creators/cardCollectionActionCreator";

class CardVehicleWiseList extends React.Component {
  constructor(props) {
    super(props);
    const m = moment(new Date());
    this.state = {
      showHeaderButton: true,
      pageNo: 0,
      totalPages: 0,
      isUserAViewer: false,
      date: m,
      todaySelectable: true,
      backdrop: false,
      rowsPerPage: 10,
      count: 100,
      selected: [],
      sortBy: "",
    };
    this.cardVehcleWiseGetList = this.cardVehcleWiseGetList.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.onSortToggle = this.onSortToggle.bind(this);
  }

  componentDidMount() {
    this.cardVehcleWiseGetList();
  }

  componentDidUpdate(prevProps) {
    const {
      searchString, cityFilter, selectedDateFilter, operatorFilter,
    } = this.props;
    if (
      (prevProps && prevProps.searchString !== searchString)
      || (prevProps && prevProps.cityFilter !== cityFilter)
      || (prevProps && prevProps.selectedDateFilter !== selectedDateFilter)
      || (prevProps && prevProps.operatorFilter !== operatorFilter)
    ) {
      this.cardVehcleWiseGetList();
    }
  }

  //   componentWillUnmount() {
  //     this.mounted = false;
  //   }

  /**
   * API call to get devices.
   * @param pageNo current page number
   */

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.cardVehcleWiseGetList();
      }
    });
  };

  // eslint-disable-next-line class-methods-use-this
  handleAction() {
    // eslint-disable-next-line no-console
    console.log("action clicked");
  }

  onSortToggle(value, key) {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.cardVehcleWiseGetList();
      },
    );
  }

  cardVehcleWiseGetList() {
    const {
      fetchVehicleWiseCardCollection, searchString, operatorFilter, cityFilter, selectedDateFilter,
    } = this.props;
    const { pageNo, rowsPerPage, sortBy } = this.state;
    fetchVehicleWiseCardCollection({
      pageNo,
      pageSize: rowsPerPage,
      searchString,
      operatorFilter,
      cityFilter,
      dateFilter: selectedDateFilter,
      sortBy,
    });
  }

  render() {
    const { headerLoader, content, totalItems } = this.props;
    const {
      selected, pageNo, rowsPerPage, sortBy,
    } = this.state;
    return (
      <div>
        <TableWrapper
          content={!headerLoader && content}
          selected={selected}
          pageNo={pageNo}
          uniqueKey="vehicle_no"
          rowsPerPage={rowsPerPage}
          count={totalItems}
          handleChange={this.handleChange}
          templateString={templateStrings.vehicleWiseCardCollection}
          selectionAllowed={false}
          handleAction={this.handleAction}
          onSortToggle={this.onSortToggle}
          sortBy={sortBy}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.CardCollection
        && state.CardCollection.vehicleWiseCardCollection
        && state.CardCollection.vehicleWiseCardCollection.data)
      || [],
    totalItems:
      (state
        && state.CardCollection
        && state.CardCollection.vehicleWiseCardCollection
        && state.CardCollection.vehicleWiseCardCollection.totalItems)
      || 0,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchVehicleWiseCardCollection: (params) => {
    dispatch(vehicleWiseCardCollectionListAction(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CardVehicleWiseList);
